(function () {
  var stacks = document.querySelectorAll('[data-testimonial-stack]');

  stacks.forEach(function (stack) {
    var cards = Array.from(stack.querySelectorAll('[data-testimonial-card]'));
    if (cards.length < 2) return;

    var interval = parseInt(stack.dataset.interval, 10) || 3000;
    var activeIndex = cards.length - 1;
    var timer;
    var handlersAttached = false;

    function randomRotation() {
      return (Math.random() * 12 - 6).toFixed(1);
    }

    var shadows = [
      '0 20px 60px -10px rgba(0,0,0,0.25)', // active
      '0 4px 8px -2px rgba(0,0,0,0.08)',     // behind-1
      '0 2px 4px -1px rgba(0,0,0,0.05)',     // behind-2+
    ];

    function update() {
      var n = cards.length;
      cards.forEach(function (card, i) {
        var dist = ((activeIndex - i) % n + n) % n;
        card.classList.remove('is-active', 'is-behind');
        card.style.pointerEvents = 'none';

        if (dist === 0) {
          card.classList.add('is-active');
          card.style.pointerEvents = 'auto';
          card.style.zIndex = n;
          card.style.boxShadow = shadows[0];
          card.style.transform = 'rotate(0deg) scale(1.02) translate(0, 0)';
        } else if (dist <= 2) {
          card.classList.add('is-behind');
          card.style.zIndex = n - dist;
          card.style.boxShadow = shadows[dist] || shadows[2];
          var scale = 1 - dist * 0.04;
          var tx = -dist * 8;
          var ty = dist * 8;
          card.style.transform = 'rotate(' + randomRotation() + 'deg) scale(' + scale + ') translate(' + tx + 'px, ' + ty + 'px)';
        } else {
          card.style.zIndex = 0;
          card.style.boxShadow = 'none';
          card.style.transform = 'scale(0.88)';
        }
      });
    }

    function flip() {
      var current = cards[activeIndex];
      current.style.transform = 'rotate(' + randomRotation() + 'deg) scale(0.95)';
      activeIndex = (activeIndex - 1 + cards.length) % cards.length;
      update();
    }

    stack.addEventListener('testimonial:ready', function () {
      activeIndex = cards.length - 1;
      // Let GSAP clean up all its inline styles before JS takes over —
      // avoids transform format mismatch that causes jumps
      if (typeof gsap !== 'undefined') {
        gsap.set(cards, { clearProps: 'all' });
      }
      update();
      clearInterval(timer);
      timer = setInterval(flip, interval);

      if (!handlersAttached) {
        handlersAttached = true;
        stack.addEventListener('mouseenter', function () { clearInterval(timer); });
        stack.addEventListener('mouseleave', function () { timer = setInterval(flip, interval); });
        stack.addEventListener('click', function () {
          flip();
          clearInterval(timer);
          timer = setInterval(flip, interval);
        });
      }
    });

    stack.addEventListener('testimonial:stop', function () {
      clearInterval(timer);
    });
  });
})();
